import React from "react"
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    styled,
} from "@mui/material"
import { COLORS } from "../../utils"
import dayjs from "dayjs"

const TAB_LABELS = {
    RECETTE: "Recette",
    ETAPES_PROD: "Étapes de prod",
    DETAILS: "Détails",
    GENERAL: "Général",
}

const StyledDialog = styled(Dialog)({
    "& .MuiPaper-root": {
        width: 500,
    },
})

const RecipeSaveConflictModal = ({ open, onSaveAnyway, onReload, conflictEntry }) => {
    if (!conflictEntry) return null

    const username = conflictEntry.user?.username || "un autre utilisateur"
    const date = conflictEntry.date ? dayjs(conflictEntry.date).format("DD/MM/YYYY à HH:mm") : ""
    const tabLabel = TAB_LABELS[conflictEntry.tab] || conflictEntry.tab

    return (
        <StyledDialog open={open} disableEscapeKeyDown>
            <DialogTitle sx={{ color: COLORS.ORANGE, fontWeight: 600 }}>
                Conflit de sauvegarde
            </DialogTitle>
            <DialogContent sx={{ color: COLORS.DRAFT_GREY, fontSize: 16 }}>
                {`La fiche a été modifiée par ${username} le ${date} sur l'onglet ${tabLabel}.`}
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "space-between", px: 2, pb: 2 }}>
                <Button onClick={onSaveAnyway} color="primary">
                    Sauvegarder quand même
                </Button>
                <Button onClick={onReload} color="primary" variant="contained">
                    Recharger la recette
                </Button>
            </DialogActions>
        </StyledDialog>
    )
}

export default RecipeSaveConflictModal
